import { FC } from "react";
import { WidgetNormalizedCostVisualization } from "@/services/cloudchipr.api";
import { NormalizedCostWidgetVisualizationSwitch } from "@/components/pages/dashboard/components/adding-widget/widget-create/widget-setups/normalized-cost-widget/side-bar/visualization/NormalizedCostWidgetVisualizationSwitch";
import { NormalizedCostWidgetScaleSelect } from "@/components/pages/dashboard/components/adding-widget/widget-create/widget-setups/normalized-cost-widget/side-bar/visualization/NormalizedCostWidgetScaleSelect";

interface NormalizedCostWidgetVisualizationItemProps {
  visualizationKey: keyof WidgetNormalizedCostVisualization;
}

export const NormalizedCostWidgetVisualizationItem: FC<
  NormalizedCostWidgetVisualizationItemProps
> = ({ visualizationKey }) => {
  if (visualizationKey === "scale") {
    return <NormalizedCostWidgetScaleSelect />;
  }

  return (
    <NormalizedCostWidgetVisualizationSwitch
      visualizationKey={visualizationKey}
    />
  );
};
